import React, { useEffect, useState } from 'react';
import styles from './index.less';
import { useIntl } from 'umi';

type truncateLinProps = {
  content: string; // 内容
  className: string; // 额外的类名
  uid: string; // 作为元素 ID
  isAccount?: boolean; // 特殊情况 当为by account来源的信息 且有回复
  showMoreFlag?: any; // 是否展示  more
};

const TruncateLine = (props: truncateLinProps) => {
  const { content, className, uid, isAccount = false } = props;

  const [showMore, setShowMore] = useState(false);
  const [clientHeight, setClientHeight] = useState(0);
  const [scrollHeight, setScrollHeight] = useState(0);

  const { formatMessage } = useIntl();

  useEffect(() => {
    isShowMore();
  }, [content]);

  const isShowMore = () => {
    const text = document.getElementById(uid);

    if (!text) return;

    setClientHeight(text?.clientHeight);
    setScrollHeight(text?.scrollHeight);

    if (text.clientHeight < text.scrollHeight || isAccount) {
      setShowMore(true);
    } else {
      setShowMore(false);
    }
    // 行高计算错误引起的bug 屏幕缩放和搜索高亮(行高范围在14~18px) 两行内不显示...more

    // TODO：暂不清楚什么逻辑
    if (text?.scrollHeight < 42 && !isAccount) {
      setShowMore(false);
    }
  };

  window.addEventListener('resize', isShowMore);

  return (
    <div className={styles['wrapper']}>
      <div className={`${styles['text']} ${className}`} id={uid}>
        {showMore && (
          <a
            className={
              styles[
                clientHeight < scrollHeight && scrollHeight < 42
                  ? 'btn'
                  : isAccount && scrollHeight < 42
                  ? 'cleanBtn'
                  : 'btn'
              ]
            }
            style={{textDecoration: 'none'}}
            onClick={() => {}}
          >
            {formatMessage({ id: 'More' })}
          </a>
        )}
        <span className={styles['contentClick']} onClick={() => {}}>
          {content}
        </span>
      </div>
    </div>
  );
};

export default TruncateLine;
